import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// Countdown utilities (reads OFFER_END_DATE from env) add default fallback date
const offerEndEnv = import.meta.env.OFFER_END_DATE || "Jan 30, 2026 23:59:59";

export function parseOfferEnd(dateStr: string): number {
    // Supports formats like: 31-Dec-2025 - 12:00 AM
    const m = dateStr.match(
        /(\d{1,2})-([A-Za-z]{3,})-(\d{4})\s*-\s*(\d{1,2}):(\d{2})\s*(AM|PM)/i
    );
    if (m) {
        const [, dd, mon, yyyy, hh, mm, ap] = m as unknown as string[];
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const monthIndex = months.findIndex(
            (x) => x.toLowerCase() === (mon as string).slice(0, 3).toLowerCase()
        );
        let h = parseInt(hh as string, 10) % 12;
        if ((ap as string).toUpperCase() === "PM") h += 12;
        const d = new Date(
            Number(yyyy),
            monthIndex < 0 ? 0 : monthIndex,
            Number(dd),
            h,
            Number(mm),
            0,
            0
        );
        return d.getTime();
    }
    // Fallback to Date parsing
    const d2 = new Date(dateStr);
    return isNaN(d2.getTime())
        ? new Date("Dec 31, 2026 23:59:59").getTime()
        : d2.getTime();
}

// Get the offer end date
export const getOfferEndDate = () => parseOfferEnd(offerEndEnv || "Dec 31, 2026 23:59:59");